import { styled } from '@mui/material'

export const TextContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  width: '100%',
  marginBottom: theme.spacing(3),

  [theme.breakpoints.up('md')]: {
    width: '205px',
  },
}))

export const Divider = styled('div')(({ theme }) => ({
  background: theme.palette.surface[200],
  height: '1px',
  width: '100%',
}))
